import React from "react";
import styled from "styled-components";
import Section from "../Utils/Section";
import Subsection from "../Utils/Subsection";

const Sidebar = ({ personalInfo }) => {
  return (
    <SidebarWrapper>
      <Photo src={personalInfo.photo} />
      <Section title="Personal Details" contrastTitle direction="column">
        <Subsection title="Address">{personalInfo.address}</Subsection>
        <Subsection title="Phone Number">{personalInfo.phoneNumber}</Subsection>
        <Subsection title="Email">{personalInfo.email}</Subsection>
      </Section>
    </SidebarWrapper>
  );
};

const SidebarWrapper = styled.div`
  padding: 2rem 0 2rem 2rem;
  background-color: ${({ theme }) => theme.colors.lightSecondary};
  box-sizing: border-box;
`;

const Photo = styled.img`
  margin-bottom: 2rem;
`;

export default Sidebar;
